export default function Configure($stateProvider) {
	$stateProvider.state('motifs-ajustement-stock', {
		parent: 'common',
		url: '/motifs-ajustement-stock',
		//abstract: true,
		views: {
			common: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			// le state étant parent et abstract, on décide de ne pas l'afficher dans le fil d'ariane
			//skip: true
			label: '{{ "LAYOUT.NAVIGATION.PARAMETRAGE" | translate }}'
		}
	});

	$stateProvider.state('motifs-ajustement-stock.list', {
		url: '/list',
		template: '<motifs-ajustement-stock></motifs-ajustement-stock>',
		rights: { domain: 'motifajuststock', right: 'read' },
		ncyBreadcrumb: {
			label: '{{ "MOTIFS_AJUSTEMENT_STOCK.BREADCRUMBS.MOTIFS_LIST" | translate}}'
		},
		// on affiche la liste des motifs dans la navigation
		navigation: {
			menu: 'stocks_configuration',
			translate: 'MOTIFS_AJUSTEMENT_STOCK.BREADCRUMBS.MOTIFS_LIST',
			order: 5
		},
		// la liste des motifs fait partie des points d'entrée recherchables dans la navigation
		search: 'MOTIFS_AJUSTEMENT_STOCK.BREADCRUMBS.MOTIFS_LIST'
	});

	$stateProvider.state('motifs-ajustement-stock.new', {
		url: '/new',
		template: '<motif-ajustement-stock-form></motif-ajustement-stock-form>',
		rights: { domain: 'motifajuststock', right: 'create' },
		ncyBreadcrumb: {
			// on décide que la liste est le parent des autres states
			// afin d'afficher motifs > ajouter
			parent: 'motifs-ajustement-stock.list',
			label: '{{ "MOTIFS_AJUSTEMENT_STOCK.BREADCRUMBS.MOTIF_NEW" | translate}}'
		},
		// l'ajout d'une motif fait partie des points d'entrée recherchables dans l'application
		search: 'MOTIFS_AJUSTEMENT_STOCK.BREADCRUMBS.MOTIF_NEW'
	});

	$stateProvider.state('motifs-ajustement-stock.edit', {
		url: '/{id}/edit',
		template: '<motif-ajustement-stock-form></motif-ajustement-stock-form>',
		rights: { domain: 'motifajuststock', right: 'update' },
		ncyBreadcrumb: {
			// on décide que la liste est le parent des autres states
			// afin d'afficher motifs > modifier
			parent: 'motifs-ajustement-stock.list',
			label: '{{ "MOTIFS_AJUSTEMENT_STOCK.BREADCRUMBS.MOTIF_EDIT" | translate }}'
		}
	});
}

Configure.$inject = ['$stateProvider'];
